<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />
    <v-col lg="12" class="ml-auto"></v-col>
    <b-card header-bg-variant="primary" header-text-variant="white">
      <template v-slot:header>
        <h6>پیگیری سفارش‌ها</h6>
      </template>
      <v-row>
        <v-col cols="10">
          <b-form-group>
            <b-form-input
              v-model="companySearchName"
              placeholder="لطفا نام مشتری یا بخشی از آن را وارد کنید"
              @keyup.enter.native="search()"
            ></b-form-input>
          </b-form-group>
        </v-col>
        <v-col cols="2">
          <b-button @click="search()">جستجوی مشتری</b-button>
        </v-col>
      </v-row>

      <br />
      <b-card
        v-if="customerOK"
        header-bg-variant="primary"
        header-text-variant="white"
      >
        <template v-slot:header>
          <h6>مشتری‌ها</h6>
        </template>
        <b-table
          responsive
          show-empty
          :items="customerItems"
          :fields="customerFields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد"
          striped
          :busy="isBusyCustomer"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(operation)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-btn class="mr-1" variant="dark" @click="showOrders(data.item)"
                >سفارش‌ها</b-btn
              >
              <a
                class="btn btn-primary color mr-1"
                target="_blank"
                :href="'/trade/customerProfile/' + data.item.customerId"
                >پرونده مشتری</a
              >
            </div>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <strong>در حال بارگذاری...</strong>
            <br />
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </b-table>
      </b-card>
      <b-card
        v-if="orderOK"
        header-bg-variant="primary"
        header-text-variant="white"
      >
        <template v-slot:header>
          <h6>سفارشات</h6>
        </template>
        <b-table
          responsive
          show-empty
          :items="orderItems"
          :fields="orderFields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد"
          striped
          :busy="isBusyOrder"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(operation)="data">
            <div style="text-align: center; vertical-align: middle">
              <a
                class="btn color mr-1 mt-1"
                :href="'/factory/order/' + data.item.perOrderId"
                target="_blank"
                role="button"
                >جزییات</a
              >
              <a
                class="btn btn-dark mr-1 mt-1"
                :href="'/' + role + '/printPreview/' + 'full/' + data.item.id"
                v-if="data.item.status != 'ثبت استعلام'"
                target="_blank"
                role="button"
                >نسخه چاپی</a
              >
            </div>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <strong>در حال بارگذاری...</strong>
            <br />
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </b-table>
      </b-card>
      <br />
    </b-card>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import moment from "moment-jalaali";
import router from "../../router";

import VueCkeditor from "vue-ckeditor2";

export default {
  components: {
    VueCkeditor,
  },
  data: function () {
    return {
      guide: false,
      customerOK: false,
      customerItems: [],
      customerFields: [
        { key: "customerCode", label: "کد مشتری" },
        { key: "name", label: "نام مشتری" },
        { key: "operation", label: "عملیات" },
      ],
      isBusyCustomer: false,
      orderOK: false,
      orderItems: [],
      orderFields: [
        { key: "code", label: "کد ردیابی" },
        { key: "letterId", label: "شماره درخواست مشتری" },
        // { key: 'subject', label: 'عنوان استعلام' },
        { key: "name", label: "نام مشتری" },
        // { key: "assignee", label: "کارشناس بازرگانی" },
        { key: "date", label: "تاریخ ثبت" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      isBusyOrder: false,

      rejectReason: "",
      companySearchName: "",
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: "",
      currentOrder: {},

      items: [],
      filter: null,
      fields1: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "index", label: "#" },
      ],
      fields2: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "description", label: "شرح کالا" },
        { key: "index", label: "#" },
      ],
      fieldsen: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "dimensionStandard", label: "Standard Size" },
        { key: "cover", label: "Cover" },
        { key: "material", label: "Grade / Material" },
        { key: "description", label: "Description" },
        { key: "index", label: "#" },
      ],
      fieldsCI: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "index", label: "#" },
      ],
      fields2CI: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "index", label: "#" },
      ],
      fieldsenCI: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "dimensionStandard", label: "Standard Size" },
        { key: "cover", label: "Cover" },
        { key: "material", label: "Grade / Material" },
        { key: "description", label: "Description" },
        { key: "customerIndex", label: "Customer Index" },
        { key: "index", label: "#" },
      ],
      uniqueValues: [],
      content: "",
      role: "",
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    showOrders(customer) {
      this.isBusyOrder = true;
      Axios.get(
        this.baseUrl +
          "/issues.json?tracker_id=30&cf_130=" +
          customer.customerId,
        {
          headers: {
            "X-Redmine-API-Key": window.localStorage.api_key,
          },
        }
      ).then((res) => {
        this.orderItems = res.data.issues.map((order) => {
          return {
            subject: order.subject || "-",
            assignee: order.assigned_to ? order.assigned_to.name : "---",
            assigneeId: order.assigned_to ? order.assigned_to.id : 0,
            name: customer.name,
            code:
              JSON.parse(
                order.custom_fields
                  .filter((x) => x.id == 195)
                  .map((y) => y.value)[0]
              ).code || "-",
            date: moment(order.created_on).format("HH:mm - jYYYY/jMM/jDD"),
            status:
              order.custom_fields
                .filter((x) => x.id == 162)
                .map((y) => y.value)[0] || "-",
            perOrderId: order.id,
            revision: order.custom_fields
              .filter((x) => x.id == 151)
              .map((y) => y.value)[0],
            letterId: order.custom_fields
              .filter((x) => x.id == 160)
              .map((y) => y.value)[0],
            customerId: order.custom_fields
              .filter((x) => x.id == 130)
              .map((y) => y.value)[0],
            taskId: order.id,
            totalOrder: order,
            sign: order.custom_fields
              .filter((x) => x.id == 163)
              .map((y) => y.value)[0],
          };
        });

        this.orderItems.sort(
          (a, b) => a.code.split("-")[2] - b.code.split("-")[2]
        );
        this.isBusyOrder = false;
        this.orderOK = true;
      });
    },

    printPreview(order, type) {
      this.$router.push(
        "/" + this.role + "/" + "printPreview/" + type + "/" + order.id
      );
    },

    search() {
      this.orderOK = false;
      this.isBusyCustomer = true;
      Axios.get(
        this.baseUrl +
          "/issues.json?tracker_id=27&subject=~" +
          this.companySearchName,
        {
          headers: {
            "X-Redmine-API-Key": window.localStorage.api_key,
          },
        }
      ).then((res) => {
        this.customerItems = res.data.issues.map((customer) => {
          return {
            name: customer.subject || "-",
            customerCode:
              customer.custom_fields
                .filter((x) => x.id == 132)
                .map((y) => y.value)[0] || "-",
            customerType:
              customer.custom_fields
                .filter((x) => x.id == 135)
                .map((y) => y.value)[0] || "-",
            priority:
              customer.custom_fields
                .filter((x) => x.id == 136)
                .map((y) => y.value)[0] || "-",
            customerId: customer.id,
          };
        });
        if (this.customerItems.length == 1) {
          this.showOrders(this.customerItems[0]);
        }
        this.isBusyCustomer = false;
        this.customerOK = true;
      });
    },
  },

  mounted() {
    // this.getTableInfo();
    this.role = window.localStorage.getItem("role");
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
